/*
 * @Descripttion: 
 * @version: 2.0.0
 * @Author: ck
 * @Date: 2019-09-11 16:17:24
 * @LastEditors: ck
 * @LastEditTime: 2019-10-24 11:51:03
 */
const _load = require('@/routers/_loadPath/_load_' + process.env.NODE_ENV)
let Views = _load('Views')
import facility from "./facility"
import software from "./software"
import pay from "./pay"


let routes = [{
    path: 'product',
    component: Views,
    name: 'product',
    meta: {
        title: '产品中心'
    },
    children: [
        ...facility,
        ...software,
        ...pay
    ]
}]

export default routes;